import {gql} from "apollo-boost";

export const GET_STUDENTENROLLDETAIL = gql`
  query getStudentEnrollDetail($id: ID!) {
    getStudentEnrollDetail(
      id: $id
    ) {
      id enrollNo studentCode sectionNo subjectCode teacherCode
      credit learnSpanNo examSpanNo isDrop
      courseOutlineRegistration{
        id periodCode
      }
      classSection{
        id studentRegisterQty studentQty
      }
      subject{
        id code nameLocal nameEng
      }
      teacher{
        id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath
      }
      student{
        id code firstNameLocal lastNameLocal firstNameEng lastNameEng
      }
      studentEnroll{
        id enrollNo periodCode studentCode enrollDate
        totalCredit totalDropCredit source
        academicPeriod{
          id periodCode
        }
      }
    }
  }
`;

export const GET_STUDENTENROLLDETAILS = gql`
  query getStudentEnrollDetails {
    getStudentEnrollDetails {
      id enrollNo studentCode sectionNo
      subjectCode teacherCode credit learnSpanNo examSpanNo isDrop
      studentEnroll {
        id
      }
      subject{
        id nameLocal nameEng
      }
      teacher{
        id code firstNameLocal lastNameLocal firstNameEng lastNameEng
        picturePath isSpecialTeacher
      }
    }
  }
`;

export const GET_STUDENTENROLLDETAILS_BY_FILTER = gql`
  query getStudentEnrollDetailsByFilter(
    $studentEnrollDetailFilterInput: StudentEnrollDetailFilterInput
  ) {
    getStudentEnrollDetailsByFilter(
      studentEnrollDetailFilterInput: $studentEnrollDetailFilterInput
    ) {
      id enrollNo studentCode sectionNo
      subjectCode teacherCode credit learnSpanNo examSpanNo isDrop
      studentEnroll {
        id
      }
      subject{
        id nameLocal nameEng
      }
      teacher{
        id code firstNameLocal lastNameLocal firstNameEng lastNameEng
        picturePath isSpecialTeacher
      }
    }
  }
`;

export const GET_ALL_STUDENT_ENROLL_DETAILS_STAT = gql`
  query getAllStudentEnrollDetailsStat(
    $academicPeriodId: ID!
    $degreeId: ID!
  ) {
    getAllStudentEnrollDetailsStat(
      academicPeriodId: $academicPeriodId
      degreeId: $degreeId
    ) {
      subjectQty
    }
  }
`;

export const ADD_STUDENTENROLLDETAILS = gql`
  mutation addStudentEnrollDetailss(
    $studentEnrollDetailsInput: [StudentEnrollDetailsInput!]
  )
  {
    addStudentEnrollDetails ( studentEnrollDetailsInput: $studentEnrollDetailsInput ){
      id enrollNo studentCode sectionNo subjectCode teacherCode
      credit learnSpanNo examSpanNo isDrop
      courseOutlineRegistration{
        id periodCode
      }
      classSection{
        id studentRegisterQty studentQty
      }
      subject{
        id code nameLocal nameEng
      }
      teacher{
        id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath
      }
      student{
        id code firstNameLocal lastNameLocal firstNameEng lastNameEng
      }
      studentEnroll{
        id enrollNo periodCode studentCode enrollDate
        totalCredit totalDropCredit source
        academicPeriod{
          id periodCode
        }
      }
    }
  }
`;

export const UPDATE_STUDENTENROLLDETAIL = gql`
  mutation updateStudentEnrollDetail(
    $id: ID!,
    $studentEnrollDetailInput: StudentEnrollDetailInput!,
    $studentEnrollId: ID,
    $studentId: ID,
    $courseOutlineRegistrationId: ID,
    $classSectionId: ID,
    $subjectId: ID,
    $teacherId: ID
  ) {
    updateStudentEnrollDetail (
      id: $id
      studentEnrollDetailInput: $studentEnrollDetailInput
    ) {
      id enrollNo studentCode sectionNo
      subjectCode teacherCode credit learnSpanNo examSpanNo isDrop
      studentEnroll {
        id
      }
      subject{
        id nameLocal nameEng
      }
      teacher{
        id code firstNameLocal lastNameLocal firstNameEng lastNameEng
        picturePath isSpecialTeacher
      }
    }
  }
`;

export const UPDATE_STUDENTENROLLDETAIL_IS_DROP = gql`
  mutation updateStudentEnrollDetailIsDrop(
    $id: ID!, $isDrop: Boolean!
  ) {
    updateStudentEnrollDetailIsDrop (
      id: $id, isDrop: $isDrop
    ) {
      id enrollNo studentCode sectionNo
      subjectCode teacherCode credit learnSpanNo examSpanNo isDrop
      studentEnroll {
        id
      }
      subject{
        id nameLocal nameEng
      }
      teacher{
        id code firstNameLocal lastNameLocal firstNameEng lastNameEng
        picturePath isSpecialTeacher
      }
    }
  }
`;

export const DELETE_STUDENTENROLLDETAIL = gql`
  mutation deleteStudentEnrollDetail(
    $id: ID!
  ) {
    deleteStudentEnrollDetail (
      id: $id
    ) {
      id enrollNo studentCode sectionNo
      subjectCode teacherCode credit learnSpanNo examSpanNo isDrop
      studentEnroll {
        id
      }
      subject{
        id nameLocal nameEng
      }
      teacher{
        id code firstNameLocal lastNameLocal firstNameEng lastNameEng
        picturePath isSpecialTeacher
      }
    }
  }
`;

export const GET_STUDENTENROLLDETAILS_STAT = gql`
  query getStudentEnrollDetailsStat(
    $studentEnrollDetailFilterInput: StudentEnrollDetailFilterInput
  ) {
    getStudentEnrollDetailsStat(
      studentEnrollDetailFilterInput: $studentEnrollDetailFilterInput
    ) {
      id enrollNo studentCode sectionNo
      subjectCode teacherCode credit learnSpanNo examSpanNo isDrop
      student {
        id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath telephone
      }
      #manual data
      expandData {
        seq totalVdoLength totalLearnTime learnPercent
        pretestMaxScore pretestScore posttestMaxScore posttestScore
      }
      studentAssignmentQty
      totalVdoLength
      totalLearnTime
      totalLearnPercent
    }
  }
`;
